import clsx from 'clsx';

/**
 * Styles shared by all buttons.
 * @param grouped Whether the button is part of a group (like a link) - it affects the hover and active styles.
 */
export const buttonClasses = clsx(
	'inline-flex',
	'overflow-hidden',
	'justify-center',
	'items-center',
	'text-center',
	'rounded-[3.5rem]', // it needs to be a set value, instead of full (9999px) for animation purposes
	'outline-none',
	'transition-all',
	'duration-200',
	'bg-forestGreen-700',
	'text-beige-500',
	'lg:text-button',
	'lg:h-12',
	'lg:px-10',
	'h-10',
	'px-8',
	'text-xs',
	'font-medium',
	'focus-visible:ring-forestGreen-700',
	'focus-visible:ring-2',
	'focus-visible:outline-none',
	'focus-visible:ring-offset-2',
	'active:shadow-focus',
	'hover:rounded-lg',
);
